export default "__VITE_ASSET__Bc8lJrz0__"